<template>
    <div>
        <div id="empfehlung-outer" v-if="therapieEmpfehlung">
            <div id="diagnostic">
                <div>Therapieempfehlung für <b>{{ confirmedDiagnose }}</b></div>
            </div>
            <div id="therapie">
                <div style="font-size: 16pt; margin-bottom: 5px">Evidenz
                    <button class="btn-info" v-on:click="therapieempfehlungClicked">
                        <b-icon-info-circle/>
                    </button>
                </div>
                <div style="background-color: lightgray; padding: 10px">
                    <ul>
                        <li v-for="therapieText in splitStringIntoArray(therapieempfehlungText, '\n')"
                            :key="therapieText">
                            {{ therapieText }}
                        </li>
                    </ul>
                </div>
                <br>
            </div>
            <div id="arzneivorschlaege">
                <div style="font-size: 16pt; margin-bottom: 5px">Arzneimittelvorschläge
                </div>
                <b-table :fields="arzneimittelvorschlagTableFields"
                         :items="therapieEmpfehlung" striped bordered
                         head-variant="light">
                    <template #head(name)>
                        <div><b>Substanzname</b></div>
                        <div style="font-size: 8pt">
                            Klicken Sie auf das
                            <b-icon-info-circle/>
                            für Hinweise zu Kontraindikationen und Wechselwirkungen.
                        </div>

                    </template>
                    <template #cell(name)="data">
                        <div><b>{{ therapieEmpfehlung.indexOf(data.item) + 1 }}. Wahl: </b></div>
                        <div v-for="medicament in data.item" :key="medicament['Medikament']"
                             style="padding-bottom: 10px">
                            <span>{{ medicament['Medikament'] }}</span>
                            <button class="btn-info" size="sm" v-on:click="arzneimittelvorschlagClicked(medicament)"
                                    v-b-tooltip.hover.right.html="medicament['Infotext']">
                                <b-icon-info-circle/>
                            </button>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
        <div style="margin: 20px; background-color: lightgray" v-else>
            KEIN MEDICATION VORHANDEN
        </div>
        <!-- $$$$$$$ MODAL FOR VIEWING ARZNEIMITTEL DETAILS $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
        <b-modal id="outer-arzneimittel-modal"
                 size="xl"
                 ok-only
                 ok-variant="outline-primary"
                 :title="lastClickedArzneimittelvorschlag ? lastClickedArzneimittelvorschlag['Medikament']: ''">
            <div id="inner-arzneimittel-modal">
                <div id="modal-dosierung">
                    <div style="font-size: 15pt">Dosierungsemfehlung:</div>
                    <ul>
                        <li v-for="dosis in splitStringIntoArray( lastClickedArzneimittelvorschlag['Dosierungsempfehlung'],'\n')"
                            :key="dosis">
                            {{ dosis }}
                        </li>
                    </ul>
                </div>
                <div id="modal-indikation">
                    <div style="font-size: 15pt">Zulassung:</div>
                    <ul>
                        <li>
                            {{ lastClickedArzneimittelvorschlag['Zulassung'] }}
                        </li>
                    </ul>
                </div>
                <div id="modal-kontraindikationen">
                    <div style="font-size: 15pt">Kontraindikatoinen:</div>
                    <ul>
                        <li v-if="lastClickedArzneimittelvorschlag['Kontraindikation']">
                            {{ lastClickedArzneimittelvorschlag['Kontraindikation'] }}
                        </li>
                        <li v-else>
                            Keine Kontraindikationen bekannt</li>
                    </ul>
                </div>
                <div id="modal-kommentar">
                    <div style="font-size: 15pt">Kommentar:</div>
                    <div>{{ lastClickedArzneimittelvorschlag['Kommentar'] }}</div>
                </div>
                <div id="modal-handelspraeparate" style="padding-top: 20px">
                    <div style="font-size: 15pt">Handelspräparate:</div>
                    <table style="width: 50%" class="table-bordered table-striped">
                        <tbody>
                        <tr v-for="handeslpraeparat in splitStringIntoArray(lastClickedArzneimittelvorschlag['Handeslpräparate'],',')"
                            :key="handeslpraeparat">
                            <td>
                                <div>{{ handeslpraeparat }}</div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-modal>
        <!-- $$$$$$$ MODAL FOR VIEWING THERAPIE DETAILS $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
        <b-modal id="outer-therapie-modal"
                 size="xl"
                 ok-only
                 ok-variant="outline-primary"
                 hide-header>
            <div id="inner-therapie-modal">
                <div id="modal-emfehlung">
                    <div style="font-size: 18pt; margin-top: 5px">Therapieempfehlung:</div>
                    <ul>
                        <li v-for="therapieText in splitStringIntoArray(therapieempfehlungText, '\n')"
                            :key="therapieText">
                            {{ therapieText }}
                        </li>
                    </ul>
                </div>
                <div id="modal-begruendung">
                    <div style="font-size: 18pt; margin-top: 10px">Begründung:</div>
                    <div v-for="begruendungText in splitStringIntoArray(begruendung, '\n')" :key="begruendungText">
                        {{ begruendungText }}
                    </div>
                </div>
                <div id="modal-referenzen">
                    <div style="font-size: 18pt; margin-top: 10px">Referenzen:</div>
                    <ul>
                        <li v-for="referenzenText in splitStringIntoArray(referenzen, '\n')" :key="referenzenText">
                            {{ referenzenText }}
                        </li>
                    </ul>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import therapieempfehlungAlgorithm from "../../../js/clinical-algorithm/therapie/therapieempfehlungAlgorithm";
import medicamentInfoConfig from "../../../js/clinical-algorithm/therapie/Stage4b_MediInformation.csv";

export default {
    name: "EmpfehlungComponent",
    data() {
        return {
            lastClickedArzneimittelvorschlag: {},
            arzneimittelvorschlagTableFields: [
                {
                    key: 'name',
                    label: 'Substanzname'
                }
            ]
        }
    },
    computed: {
        ...mapState('cdss/therapie', {
            therapieEmpfehlung: state => {
                if (state.arzneimittelvorschlaege === undefined) {
                    return undefined
                }
                let ersteWaehl = therapieempfehlungAlgorithm.readMedicamentInfo(medicamentInfoConfig)
                    .filter(info => state.arzneimittelvorschlaege[info['Medikament']] === "1")
                let zweiteWaehl = therapieempfehlungAlgorithm.readMedicamentInfo(medicamentInfoConfig)
                    .filter(info => state.arzneimittelvorschlaege[info['Medikament']] === "2")
                let dritteWaehl = therapieempfehlungAlgorithm.readMedicamentInfo(medicamentInfoConfig)
                    .filter(info => state.arzneimittelvorschlaege[info['Medikament']] === "3")
                let result = []
                result.push(ersteWaehl)
                if (zweiteWaehl.length > 0) {
                    result.push(zweiteWaehl)
                }
                if (dritteWaehl.length > 0) {
                    result.push(dritteWaehl)
                }

                return result
            },
            therapieempfehlungText: state => state.arzneimittelvorschlaege['Therapieempfehlung'],
            begruendung: state => state.arzneimittelvorschlaege['Begründung'],
            referenzen: state => state.arzneimittelvorschlaege['Referenzen'],
            rule_id: state => state.arzneimittelvorschlaege['Rule_ID']
        }),
        ...mapState('cdss/diagnosestellung', {
            confirmedDiagnose: state => state.bestaetigteDiagnose,
        })
    },
    methods: {
        arzneimittelvorschlagClicked(medi) {
            this.lastClickedArzneimittelvorschlag = medi
            this.$bvModal.show('outer-arzneimittel-modal')
        },
        therapieempfehlungClicked() {
            this.$bvModal.show('outer-therapie-modal')
        },
        splitStringIntoArray(string, separator) {
            if (string !== undefined) {
                return string.split(separator).filter(s => s !== '')
            }
        }
    }
}
</script>

<style scoped>

#empfehlung-outer {
    display: grid;
    grid-template-rows: auto auto;
    grid-template-columns: auto auto;
    grid-template-areas:
      "diagnostic diagnostic"
      "arzneivorschlaege therapie";
}

#diagnostic {
    grid-area: diagnostic;
    margin-right: 50px;
    padding-top: 10px;
    padding-left: 20px;
    font-size: 20pt;
}

#therapie {
    grid-area: therapie;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 10px;
}

#arzneivorschlaege {
    grid-area: arzneivorschlaege;
    padding-bottom: 50px;
    padding-left: 20px;
    padding-top: 10px;
}

.btn-info {
    background-color: transparent;
    border: none;
    color: #007bff;
    font-size: 15px;
    padding-bottom: 5px;
    cursor: pointer;
    vertical-align: super;
}

.btn-info:hover {
    color: black;
    text-decoration: underline;
}

#title-modal {
    font-size: 18pt;
    margin-top: 5px;
}


</style>
